/* Interactive product sections. No libraries. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
  const fmt = (n) => Math.round(n).toLocaleString();

  /* progress of a tall pinned section, 0..1 */
  const pinProgress = (el) => {
    const r = el.getBoundingClientRect();
    const range = el.offsetHeight - innerHeight;
    return range > 0 ? clamp(-r.top / range, 0, 1) : 0;
  };
  /* one scroll loop for everything that follows the scroll */
  const scrollers = [];
  let ticking = false;
  const run = () => { ticking = false; scrollers.forEach(fn => fn()); };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
  addEventListener('resize', () => requestAnimationFrame(run));

  /* ---- sideways journey ---- */
  $$('[data-jr]').forEach(sec => {
    const track = $('[data-jr-track]', sec);
    const rail = $('.jr-rail', sec);
    const wide = matchMedia('(min-width: 901px)');
    let last = -1;
    scrollers.push(() => {
      if (!wide.matches || reduce) { if (last !== -1) { track.style.transform = ''; last = -1; } return; }
      const p = pinProgress(sec);
      if (Math.abs(p - last) < 0.001) return;
      last = p;
      const pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      const max = Math.max(0, track.scrollWidth + pad - innerWidth);
      track.style.transform = `translate3d(${-p * max}px,0,0)`;
      rail.style.setProperty('--jp', p.toFixed(3));
    });
  });

  /* ---- flip cards: flip as they scroll past the middle of the screen (hover flips too) ---- */
  $$('[data-swap]').forEach(b => {
    b.setAttribute('aria-pressed', 'false');
    b.addEventListener('click', () => { b.dataset.manual = '1'; b.classList.toggle('is-flipped'); b.setAttribute('aria-pressed', b.classList.contains('is-flipped')); });
    if (reduce) { b.classList.add('is-flipped'); return; }
    let last = null;
    scrollers.push(() => {
      if (b.dataset.manual) return;
      const r = b.getBoundingClientRect();
      const on = r.top + r.height / 2 < innerHeight * 0.62;
      if (on !== last) { last = on; b.classList.toggle('is-flipped', on); b.setAttribute('aria-pressed', on); }
    });
  });
  /* ---- 30 day calendar ---- */
  $$('[data-cal]').forEach(sec => {
    const days = $$('.cal-day', sec);
    const notes = $$('.cal-note', sec);
    const out = $('[data-cal-day]', sec);
    const board = $('.cal-board', sec);
    let lastDay = -1;
    const paint = (d) => {
      if (d === lastDay) return;
      lastDay = d;
      days.forEach((el, i) => { el.classList.toggle('is-done', i < d); el.classList.toggle('is-today', i === d - 1); });
      notes.forEach(n => n.classList.toggle('is-lit', Number(n.dataset.noteDay) <= d));
      out.textContent = Math.max(1, d);
    };
    if (reduce) { paint(days.length); return; }
    scrollers.push(() => {
      const r = board.getBoundingClientRect();
      const p = clamp((innerHeight * 0.85 - r.top) / (r.height + innerHeight * 0.35), 0, 1);
      paint(Math.round(p * days.length));
    });
  });

  /* ---- pinned, scroll-driven steps (neck demo, hotspots, colours) ---- */
  const wideMQ = matchMedia('(min-width: 901px)');
  const pinned = () => wideMQ.matches && !reduce;
  /* returns a controller: step changes with scroll on wide screens, autoplays on phones */
  const stepper = (sec, count, show) => {
    let cur = -1, hold = 0, timer = null;
    const set = (i) => { if (i !== cur) { cur = i; show(i); } };
    const segTop = (i) => {
      const top = sec.getBoundingClientRect().top + scrollY;
      const range = sec.offsetHeight - innerHeight;
      return top + range * ((i + 0.5) / count);
    };
    scrollers.push(() => {
      if (!pinned()) return;
      const p = pinProgress(sec);
      sec.style.setProperty('--pp', p.toFixed(3));
      sec.classList.toggle('is-done', p > 0.97);
      if (performance.now() < hold) return;
      set(clamp(Math.floor(p * count), 0, count - 1));
    });
    /* phones: gentle autoplay while visible */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        clearInterval(timer);
        if (en.isIntersecting && !pinned() && !reduce) {
          timer = setInterval(() => { if (performance.now() > hold) set((cur + 1) % count); }, 2600);
        }
      }, { threshold: 0.4 }).observe(sec);
    }
    return {
      /* hover or tap: show it now, and on wide screens scroll to that step */
      pick: (i, jump) => {
        set(i);
        hold = performance.now() + (jump ? 900 : 4000);
        if (jump && pinned()) window.scrollTo({ top: segTop(i), behavior: 'smooth' });
      },
      peek: (i) => { set(i); hold = performance.now() + 1500; },
      init: () => set(0)
    };
  };

  /* ---- neck alignment ---- */
  $$('[data-al]').forEach(sec => {
    const fig = $('.al-fig', sec);
    const verdict = $('.al-verdict', sec);
    const tabs = $$('[data-al-set]', sec);
    const order = tabs.map(t => t.dataset.alSet);
    const st = stepper(sec, order.length, (i) => {
      const k = order[i];
      fig.dataset.state = k;
      verdict.dataset.state = k;
      tabs.forEach(t => t.setAttribute('aria-selected', t.dataset.alSet === k));
    });
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => st.pick(i, true));
      t.addEventListener('mouseenter', () => st.peek(i));
    });
    st.init();
  });

  /* ---- hotspots ---- */
  $$('[data-hs]').forEach(sec => {
    const dots = $$('.hs-dot', sec);
    const items = $$('[data-hs-item]', sec);
    const st = stepper(sec, Math.max(1, dots.length), (i) => {
      dots.forEach((d, j) => d.setAttribute('aria-expanded', i === j));
      items.forEach((it, j) => it.classList.toggle('is-on', i === j));
    });
    $$('[data-hs-dot]', sec).forEach(b => {
      const i = Number(b.dataset.hsDot);
      b.addEventListener('click', () => st.pick(i, false));
      b.addEventListener('mouseenter', () => st.peek(i));
      b.addEventListener('focus', () => st.peek(i));
    });
    st.init();
  });

  /* ---- colour showcase ---- */
  $$('[data-cl]').forEach(sec => {
    const sws = $$('[data-cl-pick]', sec);
    const st = stepper(sec, Math.max(1, sws.length), (i) => {
      sws.forEach((s, j) => s.setAttribute('aria-checked', i === j));
      $$('[data-cl-slide]', sec).forEach((s, j) => s.classList.toggle('is-on', i === j));
      $$('[data-cl-name]', sec).forEach((s, j) => s.classList.toggle('is-on', i === j));
      sec.style.setProperty('--cl-bg', sws[i].dataset.tint);
    });
    sws.forEach((s, i) => {
      s.addEventListener('mouseenter', () => st.peek(i));
      s.addEventListener('click', () => st.pick(i, false));
      s.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); const n = (i + 1) % sws.length; st.pick(n, false); sws[n].focus(); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); const n = (i - 1 + sws.length) % sws.length; st.pick(n, false); sws[n].focus(); }
      });
    });
    st.init();
  });

  /* ---- at home photo wall: drifts sideways with the scroll ---- */
  $$('[data-ugc]').forEach(sec => {
    const track = $('[data-ugc-track]', sec);
    let last = -1;
    scrollers.push(() => {
      if (!wideMQ.matches || reduce) return;
      const r = sec.getBoundingClientRect();
      const p = clamp((innerHeight - r.top) / (innerHeight + r.height), 0, 1);
      if (Math.abs(p - last) < 0.001) return;
      last = p;
      const max = Math.max(0, track.scrollWidth - innerWidth + 64);
      track.style.transform = `translate3d(${(-p * max).toFixed(1)}px,0,0)`;
    });
  });

  /* ---- a day with Restwell: tabs follow the scroll ---- */
  $$('[data-day]').forEach(sec => {
    const tabs = $$('.day-tab', sec);
    if (!tabs.length) return;
    const st = stepper(sec, tabs.length, (i) => { if (tabs[i].getAttribute('aria-selected') !== 'true') tabs[i].click(); });
    tabs.forEach((t, i) => {
      t.addEventListener('mouseenter', () => st.peek(i));
      t.addEventListener('click', (e) => { if (e.isTrusted) st.pick(i, true); });
    });
  });

  /* ---- video that plays on scroll ---- */
  $$('[data-vst]').forEach(sec => {
    const video = $('.vst-video', sec);
    const beats = $$('.vst-beat', sec);
    const src = sec.dataset.video;
    if (!src || !video) return;
    let loaded = false, ready = false, busy = false, pending = null, target = 0, shown = 0, raf = null, last = 0, lastBeat = -1;
    const seek = (t) => {
      if (!ready) return;
      if (busy) { pending = t; return; }
      busy = true; video.currentTime = t;
    };
    video.addEventListener('seeked', () => { busy = false; if (pending !== null) { const t = pending; pending = null; seek(t); } });
    video.addEventListener('error', () => { busy = false; pending = null; });
    const load = () => {
      if (loaded) return; loaded = true;
      fetch(src).then(r => r.blob()).then(b => {
        video.src = URL.createObjectURL(b);
        video.load();
        video.addEventListener('canplay', () => {
          ready = true; sec.classList.add('video-ready');
          if (!pinned()) { video.loop = true; video.play().catch(() => {}); }
          else seek(shown * (video.duration - 0.05));
        }, { once: true });
      }).catch(() => {});
    };
    new IntersectionObserver(([en]) => {
      if (en.isIntersecting) { load(); if (ready && !pinned()) video.play().catch(() => {}); }
      else if (!pinned()) video.pause();
    }, { rootMargin: '400px 0px' }).observe(sec);
    const tick = (now) => {
      const dt = Math.min(100, now - (last || now)); last = now;
      shown += (target - shown) * (1 - Math.pow(1 - 0.14, dt / 16.667));
      if (Math.abs(target - shown) < 0.0005) { shown = target; raf = null; last = 0; } else raf = requestAnimationFrame(tick);
      if (ready && video.duration) seek(shown * (video.duration - 0.05));
    };
    scrollers.push(() => {
      if (!pinned()) return;
      const p = pinProgress(sec);
      sec.style.setProperty('--pp', p.toFixed(3));
      sec.classList.toggle('is-done', p > 0.97);
      target = p;
      if (raf === null) raf = requestAnimationFrame(tick);
      const bi = clamp(Math.floor(p * beats.length), 0, beats.length - 1);
      if (bi !== lastBeat) { lastBeat = bi; beats.forEach((b, i) => b.classList.toggle('is-on', i === bi)); }
    });
  });

  /* ---- day section: play the video of the moment that is showing ---- */
  $$('[data-day]').forEach(sec => {
    const films = $$('.day-film', sec);
    if (!films.length) return;
    let onScreen = false;
    const sync = () => {
      films.forEach(v => {
        const panel = v.closest('.day-panel');
        const show = onScreen && panel && !panel.hidden;
        if (show) {
          if (!v.src) v.src = v.dataset.src;
          v.play().then(() => v.classList.add('is-playing')).catch(() => {});
        } else if (v.src) { v.pause(); }
      });
    };
    new IntersectionObserver(([en]) => { onScreen = en.isIntersecting; sync(); }, { threshold: 0.2 }).observe(sec);
    new MutationObserver(sync).observe(sec, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
  });

  /* ---- night by night moons ---- */
  $$('[data-mo]').forEach(sec => {
    const nights = $$('.mo-night', sec);
    nights.forEach((n, i) => n.style.setProperty('--d', (i * 180) + 'ms'));
    if (reduce || !('IntersectionObserver' in window)) { nights.forEach(n => n.classList.add('is-in')); return; }
    const io = new IntersectionObserver(([en]) => {
      if (!en.isIntersecting) return;
      io.disconnect();
      nights.forEach(n => n.classList.add('is-in'));
    }, { threshold: 0.3 });
    io.observe(sec);
  });

  /* ---- slider fill helper ---- */
  const fill = (r) => r.style.setProperty('--fill', ((r.value - r.min) / (r.max - r.min) * 100) + '%');

  /* ---- sliders: a short sweep the first time they appear, so people see they can drag ---- */
  const demoSlider = (range, after) => {
    if (reduce || !('IntersectionObserver' in window)) return;
    const field = range.closest('.sc-field');
    const hint = document.createElement('span');
    hint.className = 'drag-hint';
    hint.innerHTML = '&larr; Drag &rarr;';
    field && field.appendChild(hint);
    let touched = false;
    range.addEventListener('pointerdown', () => { touched = true; hint.classList.add('is-gone'); });
    range.addEventListener('keydown', () => { touched = true; hint.classList.add('is-gone'); });
    const io = new IntersectionObserver(([en]) => {
      if (!en.isIntersecting) return;
      io.disconnect();
      const start = Number(range.value), min = Number(range.min), max = Number(range.max), step = Number(range.step) || 1;
      const hi = Math.min(max, start + (max - min) * 0.35);
      const t0 = performance.now(), dur = 1800;
      const tick = (t) => {
        if (touched) return;
        const k = Math.min(1, (t - t0) / dur);
        const w = Math.sin(k * Math.PI);            /* up, then back to where it started */
        const v = Math.round((start + (hi - start) * w) / step) * step;
        if (String(v) !== range.value) { range.value = v; after(); }
        if (k < 1) requestAnimationFrame(tick); else { range.value = start; after(); }
      };
      setTimeout(() => requestAnimationFrame(tick), 400);
    }, { threshold: 0.6 });
    io.observe(range);
  };

  /* ---- step calculator ---- */
  $$('[data-sc]').forEach(sec => {
    const range = $('[data-sc-range]', sec);
    const spm = { slow: Number(sec.dataset.spmSlow) || 90, brisk: Number(sec.dataset.spmBrisk) || 115 };
    const stride = (Number(sec.dataset.stride) || 65) / 100;
    const mi = sec.dataset.unit !== 'km';
    const feet = $('[data-sc-feet]', sec);
    let lastFeet = -1;
    const calc = () => {
      const min = Number(range.value);
      const pace = ($('input[type=radio]:checked', sec) || {}).value || 'slow';
      const day = min * spm[pace];
      const km = day * 30 * stride / 1000;
      $('[data-sc-min]', sec).textContent = min;
      $('[data-sc-day]', sec).textContent = fmt(day);
      $('[data-sc-week]', sec).textContent = fmt(day * 7);
      $('[data-sc-dist]', sec).textContent = (mi ? km * 0.621371 : km).toFixed(0);
      fill(range);
      const n = clamp(Math.round(day / 400), 1, 40);
      if (n !== lastFeet) { lastFeet = n; feet.innerHTML = '<i></i>'.repeat(n); }
    };
    sec.addEventListener('input', calc);
    calc();
    demoSlider(range, calc);
  });

  /* ---- pays for itself ---- */
  $$('[data-pb]').forEach(sec => {
    const range = $('[data-pb-range]', sec);
    const price = Number(sec.dataset.price) / 100;
    const money = (n) => (window.RestwellMoney ? window.RestwellMoney(Math.round(n * 100)) : '$' + fmt(n)).replace(/\.00$/, '');
    const cols = $$('.pb-col', sec);
    const calc = () => {
      const fee = Number(range.value);
      $('[data-pb-fee]', sec).textContent = fee;
      const months = price > 0 ? Math.ceil(price / fee) : 0;
      $('[data-pb-months]', sec).textContent = months;
      $('[data-pb-save]', sec).textContent = money(Math.max(0, fee * 12 - price));
      const top = Math.max(fee * 12, price) * 1.05;
      cols.forEach((c, i) => {
        const gym = fee * (i + 1);
        c.querySelector('.pb-gym').style.height = (gym / top * 100) + '%';
        c.querySelector('.pb-pad').style.height = (price / top * 100) + '%';
        c.classList.toggle('is-paid', gym >= price);
      });
      fill(range);
    };
    range.addEventListener('input', calc);
    calc();
    demoSlider(range, calc);
  });

  /* ---- fold on scroll ---- */
  $$('[data-fd]').forEach(sec => {
    const rail = $('[data-fd-rail]', sec);
    const deck = $('.fd-deck', sec);
    const belt = $('.fd-belt', sec);
    const led = $('.fd-led', sec);
    const timer = $('[data-fd-sec]', sec);
    const steps = $$('.fd-step', sec);
    const secs = Number(sec.dataset.seconds) || 10;
    const FOLD = 79; /* degrees from upright to flat on the deck */
    let lastP = -1, lastStep = -1;
    const draw = (p) => {
      /* 0-.2 unfold, .2-.5 walk, .5-.78 fold, .78-1 slide away */
      let ang, slide = 0;
      if (p < 0.2) ang = FOLD * (1 - p / 0.2);
      else if (p < 0.5) ang = 0;
      else if (p < 0.78) ang = FOLD * ((p - 0.5) / 0.28);
      else { ang = FOLD; slide = (p - 0.78) / 0.22; }
      const move = `translate(${slide * 60}px, ${slide * 14}px) scale(${1 - slide * 0.12})`;
      rail.style.transform = `${move} rotate(${ang}deg)`;
      rail.style.transformOrigin = '112px 270px';
      deck.style.transform = move;
      deck.style.transformOrigin = '300px 300px';
      const walking = p >= 0.2 && p < 0.5;
      led.style.setProperty('--led', walking ? 1 : 0.25);
      belt.style.setProperty('--belt', (-p * 900).toFixed(0));
      timer.textContent = (p * secs).toFixed(1);
      const st = clamp(Math.floor(p * steps.length), 0, steps.length - 1);
      if (st !== lastStep) { lastStep = st; steps.forEach((s, i) => s.classList.toggle('is-on', i === st)); }
    };
    if (reduce) { steps.forEach(s => s.classList.add('is-on')); draw(0.3); timer.textContent = secs.toFixed(0); return; }
    scrollers.push(() => {
      const p = pinProgress(sec);
      if (Math.abs(p - lastP) < 0.001) return;
      lastP = p;
      draw(p);
    });
  });

  run();
})();
